/* eslint-disable max-len */
import React, { FC } from "react";

type IProps = {
  width?: number;
  height?: number;
  color?: string;
};

const SvgComponent: FC<IProps> = ({ width = 24, height = 24, color = "#262626" }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 24 24" fill="none">
    <path
      d="M12 5.95947V11.9595L16 13.9595M22 11.9595C22 17.4823 17.5228 21.9595 12 21.9595C6.47715 21.9595 2 17.4823 2 11.9595C2 6.43663 6.47715 1.95947 12 1.95947C17.5228 1.95947 22 6.43663 22 11.9595Z"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default SvgComponent;
